

// import React, { useRef, useState, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Table,
//   TableBody,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableCell,
//   TablePagination,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Typography,
//   Tabs,
//   Tab,
// } from "@mui/material";
// import { useReactToPrint } from "react-to-print";
// import CloseIcon from "@mui/icons-material/Close";

// import styles from "../../../styles.module.css";
// import {
//   Breadcrumb,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import cylinder_inventory_report from "../../../services/report/cylinder_inventory_report";
// import CustomPagination from "../../reusableComponent/CustomPagination";

// const ViewStockcyl = () => {
//   const [searchKey, setSearchKey] = useState("");
//   const [selectedPlant, setSelectedPlant] = useState("");
//   const [selectedDepot, setSelectedDepot] = useState("");
//   const [plants, setPlants] = useState([]);
//   const [depots, setDepots] = useState([]);
//   const [controller, setController] = useState({
//     page: 0,
//     rowsPerPage: 10,
//   });
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [rows, setRows] = useState([]);
//   const [activeTab, setActiveTab] = useState("plant");
//   const [openDetail, setOpenDetail] = useState(false);
//   const [dialogData, setDialogData] = useState([]);
//   const [dialogTitle, setDialogTitle] = useState("");
//     const [total_count, setTotalCount] = useState(0);

//   // Function to enrich rows with TGPL/Customer breakdowns
//   const enrichRows = (data) => {
//     return data.map((row) => {
//       const cylinders = row.cylinders || [];
//       const tgplCyls = cylinders.filter((c) => c.owner === "TGPL");
//       const customerCyls = cylinders.filter((c) => c.owner !== "TGPL");
//       const tgplTotal = tgplCyls.length;
//       const customerTotal = customerCyls.length;
//       const tgplFull = tgplCyls.filter((c) => c.status === "Full").length;
//       const customerFull = customerCyls.filter((c) => c.status === "Full").length;
//       const tgplEmpty = tgplCyls.filter((c) => c.status === "Empty").length;
//       const customerEmpty = customerCyls.filter((c) => c.status === "Empty").length;
//       const tgplInTransit = tgplCyls.filter((c) => c.booked === 1).length;
//       const customerInTransit = customerCyls.filter((c) => c.booked === 1).length;
//       // Add maintenance counts for cylinders with note "INSPREJECTED"
//       const tgplMaintenance = tgplCyls.filter((c) => c.note === "INSPREJECTED").length;
//       const customerMaintenance = customerCyls.filter((c) => c.note === "INSPREJECTED").length;

//       row.total_cylinders = cylinders.length;
//       row.full_cylinders = tgplFull + customerFull;
//       row.empty_cylinders = tgplEmpty + customerEmpty;

//       return {
//         ...row,
//         tgpl_total: tgplTotal,
//         customer_total: customerTotal,
//         tgpl_full: tgplFull,
//         customer_full: customerFull,
//         tgpl_empty: tgplEmpty,
//         customer_empty: customerEmpty,
//         tgpl_in_transit: tgplInTransit,
//         customer_in_transit: customerInTransit,
//         // Add maintenance fields
//         tgpl_maintenance: tgplMaintenance,
//         customer_maintenance: customerMaintenance,
//         tgpl_cylinders: tgplCyls,
//         customer_cylinders: customerCyls,
//         tgpl_full_cylinders: tgplCyls.filter((c) => c.status === "Full"),
//         customer_full_cylinders: customerCyls.filter((c) => c.status === "Full"),
//         tgpl_empty_cylinders: tgplCyls.filter((c) => c.status === "Empty"),
//         customer_empty_cylinders: customerCyls.filter((c) => c.status === "Empty"),
//         tgpl_in_transit_cylinders: tgplCyls.filter((c) => c.booked === 1),
//         customer_in_transit_cylinders: customerCyls.filter((c) => c.booked === 1),
//         // Add maintenance cylinder lists
//         tgpl_maintenance_cylinders: tgplCyls.filter((c) => c.note === "INSPREJECTED"),
//         customer_maintenance_cylinders: customerCyls.filter((c) => c.note === "INSPREJECTED"),
//       };
//     });
//   };

//   // Fetch data and extract unique plants and depots
//   const fetchData = async () => {
//     try {
//       setSuccessMessage(null);
//       const params = {
//         page: controller.page,
//         size: controller.rowsPerPage,
//         searchKey: searchKey || undefined,
//         plant: selectedPlant || undefined,
//         depot: selectedDepot || undefined,
//       };
//       const response = await cylinder_inventory_report.getcylinderinventoryreport(params);
//       const enrichedResponse = enrichRows(response || []);
//       setRows(enrichedResponse);
//       const uniquePlants = [...new Set(enrichedResponse.map((row) => row.plant_name).filter(Boolean))];
//       const uniqueDepots = [...new Set(enrichedResponse.map((row) => row.depot_name).filter(Boolean))];
//       setPlants(uniquePlants);
//       setDepots(uniqueDepots);
//     } catch (error) {
//       setRows([]);
//       setPlants([]);
//       setDepots([]);
//       setSuccessMessage("Error fetching data");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [controller.page, controller.rowsPerPage, searchKey, selectedPlant, selectedDepot]);

//   const handleChangePage = (event, newPage) => {
//     setController((prev) => ({ ...prev, page: newPage }));
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setController({
//       page: 0,
//       rowsPerPage: parseInt(event.target.value, 10),
//     });
//   };

//   const handleSearch = (e) => {
//     setSearchKey(e.target.value);
//   };

//   const handlePlantChange = (e) => {
//     setSelectedPlant(e.target.value);
//     setController((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleDepotChange = (e) => {
//     setSelectedDepot(e.target.value);
//     setController((prev) => ({ ...prev, page: 0 }));
//   };

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//     setSelectedPlant("");
//     setSelectedDepot("");
//     setController((prev) => ({ ...prev, page: 0 }));
//   };

//   // Handle click on counts
//   const handleCountClick = (row, type, owner) => {
//     let filteredCylinders = [];
//     let titleSuffix = "";
//     if (owner === "tgpl") {
//       titleSuffix = " (TGPL)";
//       if (type === "full") filteredCylinders = row.tgpl_full_cylinders || [];
//       else if (type === "empty") filteredCylinders = row.tgpl_empty_cylinders || [];
//       else if (type === "in_transit") filteredCylinders = row.tgpl_in_transit_cylinders || [];
//       else if (type === "maintenance") filteredCylinders = row.tgpl_maintenance_cylinders || [];
//       else filteredCylinders = row.tgpl_cylinders || [];
//     } else if (owner === "customer") {
//       titleSuffix = " (Customer)";
//       if (type === "full") filteredCylinders = row.customer_full_cylinders || [];
//       else if (type === "empty") filteredCylinders = row.customer_empty_cylinders || [];
//       else if (type === "in_transit") filteredCylinders = row.customer_in_transit_cylinders || [];
//       else if (type === "maintenance") filteredCylinders = row.customer_maintenance_cylinders || [];
//       else filteredCylinders = row.customer_cylinders || [];
//     } else {
//       if (type === "full")
//         filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.status === "Full");
//       else if (type === "empty")
//         filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.status === "Empty");
//       else if (type === "in_transit")
//         filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.booked === 1);
//       else if (type === "maintenance")
//         filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.note === "INSPREJECTED");
//       else filteredCylinders = row.cylinders || [];
//     }
//     setDialogTitle(
//       `${type.charAt(0).toUpperCase() + type.slice(1).replace("_", " ")} Cylinders${titleSuffix} at ${
//         row.plant_name || row.depot_name || "Location"
//       }`
//     );
//     setDialogData(filteredCylinders);
//     setOpenDetail(true);
//   };

//   const handleClose = () => {
//     setOpenDetail(false);
//     setDialogData([]);
//     setDialogTitle("");
//   };

//   // Filter rows based on active tab
//   const filteredRows = rows.filter((row) => {
//     const matchesSearch =
//       (row.plant_name?.toLowerCase().includes(searchKey.toLowerCase()) || false) ||
//       (row.depot_name?.toLowerCase().includes(searchKey.toLowerCase()) || false);

//     if (activeTab === "plant") {
//       const hasPlant = !!row.plant_name;
//       const matchPlant = selectedPlant ? row.plant_name === selectedPlant : true;
//       return hasPlant && matchPlant && matchesSearch;
//     } else {
//       const hasDepot = !!row.depot_name;
//       const matchDepot = selectedDepot ? row.depot_name === selectedDepot : true;
//       return hasDepot && matchDepot && matchesSearch;
//     }
//   });

//   // Pagination logic
//   const start = controller.page * controller.rowsPerPage;
//   const end = start + controller.rowsPerPage;
//   const paginatedRows = filteredRows.slice(start, end);
//   const paginationInfo = `${start + 1}-${Math.min(end, filteredRows.length)} of ${filteredRows.length}`;

//   const printRef = useRef();
//   const printFunction = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: "Cylinder Stock Report",
//     removeAfterPrint: true,
//   });

//   const handlePrint = () => {
//     printFunction();
//   };

//   return (
//     <Box className={styles.cts_page}>
//       <Box className={styles.body}>
//         <Breadcrumb routeSegments={[{ name: "View Cylinder Stock" }]} />

//         {/* ── Top bar: Title | Print + Search ── */}
//       {/* ── Title ── */}
// <Typography sx={{ color: "#000000", fontFamily: "Inter, sans-serif", fontSize: "16px", fontWeight: 700, mb: 1}}>
//   VIEW CYLINDER STOCK
// </Typography>

// {/* ── Below title: Print + Search + Plant/Depot dropdown ── */}
// <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>

//   {/* Print button */}
//   <Box
//     component="button"
//     onClick={handlePrint}
//     sx={{
//       display: "flex", alignItems: "center", justifyContent: "center",
//       height: 35, px: 2.5, border: "none",
//       background: "#4CAF50", color: "#fff", cursor: "pointer",
//       fontSize: 14, "&:hover": { background: "#388E3C" },
//     }}
//   >
//     Print 🖨
//   </Box>

//   {/* Search input */}
//   <Box
//     component="input"
//     placeholder="🔍  Search..."
//     value={searchKey}
//     onChange={handleSearch}
//     sx={{
//       height: 35,
//       border: "1px solid #949596",
//       fontFamily: "Inter, sans-serif", fontSize: 14,
//       color: "#1C3A5E", outline: "none", width: 1000,
//       px: 1,
//       "&:focus": { borderColor: "#1C3A5E" },
//       "&::placeholder": { color: "#9ca3af" },
//     }}
//   />

//   {/* Plant dropdown */}
//   {activeTab === "plant" && (
//     <FormControl sx={{ width: 160, height: 35 }} size="small">
//       <InputLabel sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>Plant</InputLabel>
//       <Select value={selectedPlant} onChange={handlePlantChange} label="Plant"
//         sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, height: 35 }}>
//         <MenuItem value="">All Plants</MenuItem>
//         {plants.map((plant) => <MenuItem key={plant} value={plant}>{plant}</MenuItem>)}
//       </Select>
//     </FormControl>
//   )}

//   {/* Depot dropdown */}
//   {activeTab === "depot" && (
//     <FormControl sx={{ width: 160, height: 35 }} size="small">
//       <InputLabel sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>Depot</InputLabel>
//       <Select value={selectedDepot} onChange={handleDepotChange} label="Depot"
//         sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, height: 35 }}>
//         <MenuItem value="">All Depots</MenuItem>
//         {depots.map((depot) => <MenuItem key={depot} value={depot}>{depot}</MenuItem>)}
//       </Select>
//     </FormControl>
//   )}
// </Box>

// {/* ── Tabs only ── */}
// <Box sx={{ mb: 2 }}>
//   <Tabs
//     value={activeTab}
//     onChange={handleTabChange}
//     sx={{
//       "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontFamily: "Inter, sans-serif", fontSize: 14 },
//       "& .Mui-selected": { color: "#1C3A5E !important" },
//       "& .MuiTabs-indicator": { backgroundColor: "#1C3A5E" },
//     }}
//   >
//     <Tab label="Plant-Wise" value="plant" />
//     <Tab label="Depot-Wise" value="depot" />
//   </Tabs>
// </Box>

//         {/* ── Table ── */}
//         <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>

//           {/* Print-only version (hidden on screen) */}
//           <Box ref={printRef} sx={{ display: "none", "@media print": { display: "block" }, p: 4, backgroundColor: "#fff" }}>
//             <div style={{ fontFamily: "Arial, sans-serif" }}>
//               <h1 style={{ textAlign: "left", fontSize: "20px", marginBottom: "10px" }}>Cylinder Stock Report</h1>
//               <p style={{ textAlign: "left", fontSize: "12px", marginBottom: "20px" }}>Generated on {new Date().toLocaleDateString()}</p>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     <StyledTableCell rowSpan={2}>Location</StyledTableCell>
//                     <StyledTableCell rowSpan={2}>Product Code</StyledTableCell>
//                     <StyledTableCell align="center" rowSpan={2}>Total No of Cylinder</StyledTableCell>
//                     <StyledTableCell align="center" colSpan={2}>Full</StyledTableCell>
//                     <StyledTableCell align="center" colSpan={2}>Empty</StyledTableCell>
//                     {activeTab === "depot" && <StyledTableCell align="center" colSpan={2}>In-Transit</StyledTableCell>}
//                     {activeTab === "plant" && <StyledTableCell align="center" colSpan={2}>Maintenance</StyledTableCell>}
//                   </TableRow>
//                   <TableRow>
//                     <StyledTableCell align="center">TGPL</StyledTableCell>
//                     <StyledTableCell align="center">Customer</StyledTableCell>
//                     <StyledTableCell align="center">TGPL</StyledTableCell>
//                     <StyledTableCell align="center">Customer</StyledTableCell>
//                     {activeTab === "depot" && <><StyledTableCell align="center">TGPL</StyledTableCell><StyledTableCell align="center">Customer</StyledTableCell></>}
//                     {activeTab === "plant" && <><StyledTableCell align="center">TGPL</StyledTableCell><StyledTableCell align="center">Customer</StyledTableCell></>}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {filteredRows.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <StyledTableCell>{row.plant_name || row.depot_name || "-"}</StyledTableCell>
//                       <StyledTableCell>{row.prod_code || "-"}</StyledTableCell>
//                       <StyledTableCell align="center">{row.total_cylinders || 0}</StyledTableCell>
//                       <StyledTableCell align="center">{row.tgpl_full || 0}</StyledTableCell>
//                       <StyledTableCell align="center">{row.customer_full || 0}</StyledTableCell>
//                       <StyledTableCell align="center">{row.tgpl_empty || 0}</StyledTableCell>
//                       <StyledTableCell align="center">{row.customer_empty || 0}</StyledTableCell>
//                       {activeTab === "depot" && <><StyledTableCell align="center">{row.tgpl_in_transit || 0}</StyledTableCell><StyledTableCell align="center">{row.customer_in_transit || 0}</StyledTableCell></>}
//                       {activeTab === "plant" && <><StyledTableCell align="center">{row.tgpl_maintenance || 0}</StyledTableCell><StyledTableCell align="center">{row.customer_maintenance || 0}</StyledTableCell></>}
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </div>
//           </Box>

//           {/* Screen table */}
//           <TableContainer>
//             <Table size="small" stickyHeader>
//               <TableHead>
//                 {/* Row 1 — group headers */}
//                 <TableRow>
//                   {[
//                     { label: "Location", rowSpan: 2 },
//                     { label: "Product Code", rowSpan: 2 },
//                     { label: "Total No of Cylinder", rowSpan: 2 },
//                   ].map((col) => (
//                     <TableCell
//                       key={col.label}
//                       align="center"
//                       rowSpan={col.rowSpan}
//                       sx={{
//                         backgroundColor: "#1C3A5E !important",
//                         color: "#fff !important",
//                         fontFamily: "Inter, sans-serif",
//                         fontWeight: 700,
//                         fontSize: 13,
//                         padding: "10px 16px",
//                         borderRight: "1px solid rgba(255,255,255,0.15)",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {col.label}
//                     </TableCell>
//                   ))}
//                   {[
//                     { label: "Full", colSpan: 2, bg: "#1C3A5E" },
//                     { label: "Empty", colSpan: 2, bg: "#1C3A5E" },
//                     { label: activeTab === "depot" ? "In-Transit" : "Maintenance", colSpan: 2, bg: "#1C3A5E" },
//                   ].map((grp) => (
//                     <TableCell
//                       key={grp.label}
//                       align="center"
//                       colSpan={grp.colSpan}
//                       sx={{
//                         backgroundColor: `${grp.bg} !important`,
//                         color: "#fff !important",
//                         fontFamily: "Inter, sans-serif",
//                         fontWeight: 700,
//                         fontSize: 13,
//                         padding: "10px 16px",
//                         borderRight: "1px solid rgba(255,255,255,0.2)",
//                         borderBottom: "1px solid rgba(255,255,255,0.2)",
//                       }}
//                     >
//                       {grp.label}
//                     </TableCell>
//                   ))}
//                 </TableRow>

//                 {/* Row 2 — TGPL / Customer sub-headers */}
//                 <TableRow>
//                   {["TGPL", "Customer", "TGPL", "Customer", "TGPL", "Customer"].map((lbl, i) => (
//                     <TableCell
//                       key={i}
//                       align="center"
//                       sx={{
//                         backgroundColor: "#2A4F7A !important",
//                         color: "#e2e8f0 !important",
//                         fontFamily: "Inter, sans-serif",
//                         fontWeight: 600,
//                         fontSize: 12,
//                         padding: "6px 12px",
//                         borderRight: "1px solid rgba(255,255,255,0.1)",
//                         top: 41,   /* push below first header row */
//                       }}
//                     >
//                       {lbl}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>

//               <TableBody sx={{ backgroundColor: "#fff" }}>
//                 {paginatedRows.length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={9} align="center" sx={{ py: 4, color: "#6b7280", fontFamily: "Inter, sans-serif" }}>
//                       No records found
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   paginatedRows.map((row, index) => (
//                     <StyledTableRow key={index}>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>
//                         {row.plant_name || row.depot_name || "-"}
//                       </TableCell>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>
//                         {row.prod_code || "-"}
//                       </TableCell>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2", fontWeight: 600 }}
//                         onClick={() => handleCountClick(row, "total")}>
//                         {row.total_cylinders}
//                       </TableCell>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                         onClick={() => handleCountClick(row, "full", "tgpl")}>{row.tgpl_full || 0}</TableCell>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                         onClick={() => handleCountClick(row, "full", "customer")}>{row.customer_full || 0}</TableCell>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                         onClick={() => handleCountClick(row, "empty", "tgpl")}>{row.tgpl_empty || 0}</TableCell>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                         onClick={() => handleCountClick(row, "empty", "customer")}>{row.customer_empty || 0}</TableCell>
//                       {activeTab === "depot" && (
//                         <>
//                           <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                             onClick={() => handleCountClick(row, "in_transit", "tgpl")}>{row.tgpl_in_transit || 0}</TableCell>
//                           <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                             onClick={() => handleCountClick(row, "in_transit", "customer")}>{row.customer_in_transit || 0}</TableCell>
//                         </>
//                       )}
//                       {activeTab === "plant" && (
//                         <>
//                           <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                             onClick={() => handleCountClick(row, "maintenance", "tgpl")}>{row.tgpl_maintenance || 0}</TableCell>
//                           <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
//                             onClick={() => handleCountClick(row, "maintenance", "customer")}>{row.customer_maintenance || 0}</TableCell>
//                         </>
//                       )}
//                     </StyledTableRow>
//                   ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>

//                        <CustomPagination
//   page={controller.page}
//   rowsPerPage={controller.rowsPerPage}
//   totalCount={total_count || 0}
//   onPageChange={(newPage) => handleChangePage(null, newPage)}
// />
//         </Paper>

//         {/* ── Cylinder Detail Dialog ── */}
//         <Dialog
//           PaperProps={{ sx: { minWidth: "90%", maxHeight: "90%", borderRadius: 2 } }}
//           onClose={handleClose}
//           open={openDetail}
//         >
//           <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontFamily: "Inter, sans-serif", fontWeight: 700, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//             {dialogTitle}
//             <IconButton aria-label="close" onClick={handleClose} sx={{ color: "#fff" }}>
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent dividers>
//             <TableContainer component={Paper}>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <TableRow>
//                     {["Sr No", "Cylinder No", "Tag No", "Owner", "Booked", "Status", "Note", "Storage"].map((h) => (
//                       <TableCell key={h} align="left" sx={{ backgroundColor: "#1C3A5E !important", color: "#fff !important", fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: 13 }}>
//                         {h}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody sx={{ backgroundColor: "#fff" }}>
//                   {dialogData.map((cyl, index) => (
//                     <StyledTableRow key={index}>
//                       <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{index + 1}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.cylinder_no}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.tag_no}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.owner}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.booked}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.status || "-"}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.note || "-"}</TableCell>
//                       <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.storage || "-"}</TableCell>
//                     </StyledTableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </DialogContent>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(event, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </Box>
//   );
// };

// export default ViewStockcyl;



import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import CloseIcon from "@mui/icons-material/Close";

import styles from "../../../styles.module.css";
import {
  Breadcrumb,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import cylinder_inventory_report from "../../../services/report/cylinder_inventory_report";
import CustomPagination from "../../reusableComponent/CustomPagination";

const ViewStockcyl = () => {
  const [searchKey, setSearchKey] = useState("");
  const [selectedPlant, setSelectedPlant] = useState("");
  const [selectedDepot, setSelectedDepot] = useState("");
  const [plants, setPlants] = useState([]);
  const [depots, setDepots] = useState([]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 10,
  });
  const [successMessage, setSuccessMessage] = useState(null);
  const [rows, setRows] = useState([]);
  const [activeTab, setActiveTab] = useState("plant");
  const [openDetail, setOpenDetail] = useState(false);
  const [dialogData, setDialogData] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");
    const [total_count, setTotalCount] = useState(0);

  // Function to enrich rows with TGPL/Customer breakdowns
  const enrichRows = (data) => {
    return data.map((row) => {
      const cylinders = row.cylinders || [];
      const tgplCyls = cylinders.filter((c) => c.owner === "TGPL");
      const customerCyls = cylinders.filter((c) => c.owner !== "TGPL");
      const tgplTotal = tgplCyls.length;
      const customerTotal = customerCyls.length;
      const tgplFull = tgplCyls.filter((c) => c.status === "Full").length;
      const customerFull = customerCyls.filter((c) => c.status === "Full").length;
      const tgplEmpty = tgplCyls.filter((c) => c.status === "Empty").length;
      const customerEmpty = customerCyls.filter((c) => c.status === "Empty").length;
      const tgplInTransit = tgplCyls.filter((c) => c.booked_for_challan === 1).length;
      const customerInTransit = customerCyls.filter((c) => c.booked_for_challan === 1).length;
      // Add maintenance counts for cylinders with note "INSPREJECTED"
      const tgplMaintenance = tgplCyls.filter((c) => c.result === "INSPFAIL").length;
      const customerMaintenance = customerCyls.filter((c) => c.result === "INSPFAIL").length;

      row.total_cylinders = cylinders.length;
      row.full_cylinders = tgplFull + customerFull;
      row.empty_cylinders = tgplEmpty + customerEmpty;

      return {
        ...row,
        tgpl_total: tgplTotal,
        customer_total: customerTotal,
        tgpl_full: tgplFull,
        customer_full: customerFull,
        tgpl_empty: tgplEmpty,
        customer_empty: customerEmpty,
        tgpl_in_transit: tgplInTransit,
        customer_in_transit: customerInTransit,
        // Add maintenance fields
        tgpl_maintenance: tgplMaintenance,
        customer_maintenance: customerMaintenance,
        tgpl_cylinders: tgplCyls,
        customer_cylinders: customerCyls,
        tgpl_full_cylinders: tgplCyls.filter((c) => c.status === "Full"),
        customer_full_cylinders: customerCyls.filter((c) => c.status === "Full"),
        tgpl_empty_cylinders: tgplCyls.filter((c) => c.status === "Empty"),
        customer_empty_cylinders: customerCyls.filter((c) => c.status === "Empty"),
        tgpl_in_transit_cylinders: tgplCyls.filter((c) => c.booked_for_challan === 1),
        customer_in_transit_cylinders: customerCyls.filter((c) => c.booked_for_challan === 1),
        // Add maintenance cylinder lists
        tgpl_maintenance_cylinders: tgplCyls.filter((c) => c.result === "INSPFAIL"),
        customer_maintenance_cylinders: customerCyls.filter((c) => c.result === "INSPFAIL"),
      };
    });
  };

  // Fetch data and extract unique plants and depots
  const fetchData = async () => {
    try {
      setSuccessMessage(null);
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey || undefined,
        plant: selectedPlant || undefined,
        depot: selectedDepot || undefined,
      };
      const response = await cylinder_inventory_report.getcylinderinventoryreport(params);
      const enrichedResponse = enrichRows(response || []);
      setRows(enrichedResponse);
      const uniquePlants = [...new Set(enrichedResponse.map((row) => row.plant_name).filter(Boolean))];
      const uniqueDepots = [...new Set(enrichedResponse.map((row) => row.depot_name).filter(Boolean))];
      setPlants(uniquePlants);
      setDepots(uniqueDepots);
    } catch (error) {
      setRows([]);
      setPlants([]);
      setDepots([]);
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller.page, controller.rowsPerPage, searchKey, selectedPlant, selectedDepot]);

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    });
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
  };

  const handlePlantChange = (e) => {
    setSelectedPlant(e.target.value);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const handleDepotChange = (e) => {
    setSelectedDepot(e.target.value);
    setController((prev) => ({ ...prev, page: 0 }));
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setSelectedPlant("");
    setSelectedDepot("");
    setController((prev) => ({ ...prev, page: 0 }));
  };

  // Handle click on counts
  const handleCountClick = (row, type, owner) => {
    let filteredCylinders = [];
    let titleSuffix = "";
    if (owner === "tgpl") {
      titleSuffix = " (TGPL)";
      if (type === "full") filteredCylinders = row.tgpl_full_cylinders || [];
      else if (type === "empty") filteredCylinders = row.tgpl_empty_cylinders || [];
      else if (type === "in_transit") filteredCylinders = row.tgpl_in_transit_cylinders || [];
      else if (type === "maintenance") filteredCylinders = row.tgpl_maintenance_cylinders || [];
      else filteredCylinders = row.tgpl_cylinders || [];
    } else if (owner === "customer") {
      titleSuffix = " (Customer)";
      if (type === "full") filteredCylinders = row.customer_full_cylinders || [];
      else if (type === "empty") filteredCylinders = row.customer_empty_cylinders || [];
      else if (type === "in_transit") filteredCylinders = row.customer_in_transit_cylinders || [];
      else if (type === "maintenance") filteredCylinders = row.customer_maintenance_cylinders || [];
      else filteredCylinders = row.customer_cylinders || [];
    } else {
      if (type === "full")
        filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.status === "Full");
      else if (type === "empty")
        filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.status === "Empty");
      else if (type === "in_transit")
        filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.booked_for_challan === 1);
      else if (type === "maintenance")
        filteredCylinders = (row.cylinders || []).filter((cylinder) => cylinder.note === "INSPREJECTED");
      else filteredCylinders = row.cylinders || [];
    }
    setDialogTitle(
      `${type.charAt(0).toUpperCase() + type.slice(1).replace("_", " ")} Cylinders${titleSuffix} at ${
        row.plant_name || row.depot_name || "Location"
      }`
    );
    setDialogData(filteredCylinders);
    setOpenDetail(true);
  };

  const handleClose = () => {
    setOpenDetail(false);
    setDialogData([]);
    setDialogTitle("");
  };

  // Filter rows based on active tab
  const filteredRows = rows.filter((row) => {
    const matchesSearch =
      (row.plant_name?.toLowerCase().includes(searchKey.toLowerCase()) || false) ||
      (row.depot_name?.toLowerCase().includes(searchKey.toLowerCase()) || false);

    if (activeTab === "plant") {
      const hasPlant = !!row.plant_name;
      const matchPlant = selectedPlant ? row.plant_name === selectedPlant : true;
      return hasPlant && matchPlant && matchesSearch;
    } else {
      const hasDepot = !!row.depot_name;
      const matchDepot = selectedDepot ? row.depot_name === selectedDepot : true;
      return hasDepot && matchDepot && matchesSearch;
    }
  });

  // Pagination logic
  const start = controller.page * controller.rowsPerPage;
  const end = start + controller.rowsPerPage;
  const paginatedRows = filteredRows.slice(start, end);
  const paginationInfo = `${start + 1}-${Math.min(end, filteredRows.length)} of ${filteredRows.length}`;

  const printRef = useRef();
  const printFunction = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Cylinder Stock Report",
    removeAfterPrint: true,
  });

  const handlePrint = () => {
    printFunction();
  };

  return (
    <Box className={styles.cts_page}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "View Cylinder Stock" }]} />

        {/* ── Top bar: Title | Print + Search ── */}
      {/* ── Title ── */}
<Typography sx={{ color: "#000000", fontFamily: "Inter, sans-serif", fontSize: "16px", fontWeight: 700, mb: 1}}>
  VIEW CYLINDER STOCK
</Typography>

{/* ── Below title: Print + Search + Plant/Depot dropdown ── */}
<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>

  {/* Print button */}
  <Box
    component="button"
    onClick={handlePrint}
    sx={{
      display: "flex", alignItems: "center", justifyContent: "center",
      height: 35, px: 2.5, border: "none",
      background: "#4CAF50", color: "#fff", cursor: "pointer",
      fontSize: 14, "&:hover": { background: "#388E3C" },
    }}
  >
    Print 🖨
  </Box>

  {/* Search input */}
  <Box
    component="input"
    placeholder="🔍  Search..."
    value={searchKey}
    onChange={handleSearch}
    sx={{
      height: 35,
      border: "1px solid #949596",
      fontFamily: "Inter, sans-serif", fontSize: 14,
      color: "#1C3A5E", outline: "none", width: 1000,
      px: 1,
      "&:focus": { borderColor: "#1C3A5E" },
      "&::placeholder": { color: "#9ca3af" },
    }}
  />

  {/* Plant dropdown */}
  {activeTab === "plant" && (
    <FormControl sx={{ width: 160, height: 35 }} size="small">
      <InputLabel sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>Plant</InputLabel>
      <Select value={selectedPlant} onChange={handlePlantChange} label="Plant"
        sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, height: 35 }}>
        <MenuItem value="">All Plants</MenuItem>
        {plants.map((plant) => <MenuItem key={plant} value={plant}>{plant}</MenuItem>)}
      </Select>
    </FormControl>
  )}

  {/* Depot dropdown */}
  {activeTab === "depot" && (
    <FormControl sx={{ width: 160, height: 35 }} size="small">
      <InputLabel sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>Depot</InputLabel>
      <Select value={selectedDepot} onChange={handleDepotChange} label="Depot"
        sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, height: 35 }}>
        <MenuItem value="">All Depots</MenuItem>
        {depots.map((depot) => <MenuItem key={depot} value={depot}>{depot}</MenuItem>)}
      </Select>
    </FormControl>
  )}
</Box>

{/* ── Tabs only ── */}
<Box sx={{ mb: 2 }}>
  <Tabs
    value={activeTab}
    onChange={handleTabChange}
    sx={{
      "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontFamily: "Inter, sans-serif", fontSize: 14 },
      "& .Mui-selected": { color: "#1C3A5E !important" },
      "& .MuiTabs-indicator": { backgroundColor: "#1C3A5E" },
    }}
  >
    <Tab label="Plant-Wise" value="plant" />
    <Tab label="Depot-Wise" value="depot" />
  </Tabs>
</Box>

        {/* ── Table ── */}
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>

          {/* Print-only version (hidden on screen) */}
          <Box ref={printRef} sx={{ display: "none", "@media print": { display: "block" }, p: 4, backgroundColor: "#fff" }}>
            <div style={{ fontFamily: "Arial, sans-serif" }}>
              <h1 style={{ textAlign: "left", fontSize: "20px", marginBottom: "10px" }}>Cylinder Stock Report</h1>
              <p style={{ textAlign: "left", fontSize: "12px", marginBottom: "20px" }}>Generated on {new Date().toLocaleDateString()}</p>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell rowSpan={2}>Location</StyledTableCell>
                    <StyledTableCell rowSpan={2}>Product Code</StyledTableCell>
                    <StyledTableCell align="center" rowSpan={2}>Total No of Cylinder</StyledTableCell>
                    <StyledTableCell align="center" colSpan={2}>Full</StyledTableCell>
                    <StyledTableCell align="center" colSpan={2}>Empty</StyledTableCell>
                    {activeTab === "depot" && <StyledTableCell align="center" colSpan={2}>In-Transit</StyledTableCell>}
                    {activeTab === "plant" && <StyledTableCell align="center" colSpan={2}>Maintenance</StyledTableCell>}
                  </TableRow>
                  <TableRow>
                    <StyledTableCell align="center">TGPL</StyledTableCell>
                    <StyledTableCell align="center">Customer</StyledTableCell>
                    <StyledTableCell align="center">TGPL</StyledTableCell>
                    <StyledTableCell align="center">Customer</StyledTableCell>
                    {activeTab === "depot" && <><StyledTableCell align="center">TGPL</StyledTableCell><StyledTableCell align="center">Customer</StyledTableCell></>}
                    {activeTab === "plant" && <><StyledTableCell align="center">TGPL</StyledTableCell><StyledTableCell align="center">Customer</StyledTableCell></>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredRows.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{row.plant_name || row.depot_name || "-"}</StyledTableCell>
                      <StyledTableCell>{row.prod_code || "-"}</StyledTableCell>
                      <StyledTableCell align="center">{row.total_cylinders || 0}</StyledTableCell>
                      <StyledTableCell align="center">{row.tgpl_full || 0}</StyledTableCell>
                      <StyledTableCell align="center">{row.customer_full || 0}</StyledTableCell>
                      <StyledTableCell align="center">{row.tgpl_empty || 0}</StyledTableCell>
                      <StyledTableCell align="center">{row.customer_empty || 0}</StyledTableCell>
                      {activeTab === "depot" && <><StyledTableCell align="center">{row.tgpl_in_transit || 0}</StyledTableCell><StyledTableCell align="center">{row.customer_in_transit || 0}</StyledTableCell></>}
                      {activeTab === "plant" && <><StyledTableCell align="center">{row.tgpl_maintenance || 0}</StyledTableCell><StyledTableCell align="center">{row.customer_maintenance || 0}</StyledTableCell></>}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Box>

          {/* Screen table */}
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableHead>
                {/* Row 1 — group headers */}
                <TableRow>
                  {[
                    { label: "Location", rowSpan: 2 },
                    { label: "Product Code", rowSpan: 2 },
                    { label: "Total No of Cylinder", rowSpan: 2 },
                  ].map((col) => (
                    <TableCell
                      key={col.label}
                      align="center"
                      rowSpan={col.rowSpan}
                      sx={{
                        backgroundColor: "#1C3A5E !important",
                        color: "#fff !important",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 700,
                        fontSize: 13,
                        padding: "10px 16px",
                        borderRight: "1px solid rgba(255,255,255,0.15)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                  {[
                    { label: "Full", colSpan: 2, bg: "#1C3A5E" },
                    { label: "Empty", colSpan: 2, bg: "#1C3A5E" },
                    { label: activeTab === "depot" ? "In-Transit" : "Maintenance", colSpan: 2, bg: "#1C3A5E" },
                  ].map((grp) => (
                    <TableCell
                      key={grp.label}
                      align="center"
                      colSpan={grp.colSpan}
                      sx={{
                        backgroundColor: `${grp.bg} !important`,
                        color: "#fff !important",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 700,
                        fontSize: 13,
                        padding: "10px 16px",
                        borderRight: "1px solid rgba(255,255,255,0.2)",
                        borderBottom: "1px solid rgba(255,255,255,0.2)",
                      }}
                    >
                      {grp.label}
                    </TableCell>
                  ))}
                </TableRow>

                {/* Row 2 — TGPL / Customer sub-headers */}
                <TableRow>
                  {["TGPL", "Customer", "TGPL", "Customer", "TGPL", "Customer"].map((lbl, i) => (
                    <TableCell
                      key={i}
                      align="center"
                      sx={{
                        backgroundColor: "#2A4F7A !important",
                        color: "#e2e8f0 !important",
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 600,
                        fontSize: 12,
                        padding: "6px 12px",
                        borderRight: "1px solid rgba(255,255,255,0.1)",
                        top: 41,   /* push below first header row */
                      }}
                    >
                      {lbl}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody sx={{ backgroundColor: "#fff" }}>
                {paginatedRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 4, color: "#6b7280", fontFamily: "Inter, sans-serif" }}>
                      No records found
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((row, index) => (
                    <StyledTableRow key={index}>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>
                        {row.plant_name || row.depot_name || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>
                        {row.prod_code || "-"}
                      </TableCell>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2", fontWeight: 600 }}
                        onClick={() => handleCountClick(row, "total")}>
                        {row.total_cylinders}
                      </TableCell>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                        onClick={() => handleCountClick(row, "full", "tgpl")}>{row.tgpl_full || 0}</TableCell>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                        onClick={() => handleCountClick(row, "full", "customer")}>{row.customer_full || 0}</TableCell>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                        onClick={() => handleCountClick(row, "empty", "tgpl")}>{row.tgpl_empty || 0}</TableCell>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                        onClick={() => handleCountClick(row, "empty", "customer")}>{row.customer_empty || 0}</TableCell>
                      {activeTab === "depot" && (
                        <>
                          <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                            onClick={() => handleCountClick(row, "in_transit", "tgpl")}>{row.tgpl_in_transit || 0}</TableCell>
                          <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                            onClick={() => handleCountClick(row, "in_transit", "customer")}>{row.customer_in_transit || 0}</TableCell>
                        </>
                      )}
                      {activeTab === "plant" && (
                        <>
                          <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                            onClick={() => handleCountClick(row, "maintenance", "tgpl")}>{row.tgpl_maintenance || 0}</TableCell>
                          <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13, cursor: "pointer", color: "#1976d2" }}
                            onClick={() => handleCountClick(row, "maintenance", "customer")}>{row.customer_maintenance || 0}</TableCell>
                        </>
                      )}
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

                       <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        {/* ── Cylinder Detail Dialog ── */}
        <Dialog
          PaperProps={{ sx: { minWidth: "90%", maxHeight: "90%", borderRadius: 2 } }}
          onClose={handleClose}
          open={openDetail}
        >
          <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontFamily: "Inter, sans-serif", fontWeight: 700, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {dialogTitle}
            <IconButton aria-label="close" onClick={handleClose} sx={{ color: "#fff" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <TableContainer component={Paper}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {["Sr No", "Cylinder No", "Tag No", "Owner", "Booked", "Status", "Note", "Storage"].map((h) => (
                      <TableCell key={h} align="left" sx={{ backgroundColor: "#1C3A5E !important", color: "#fff !important", fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: 13 }}>
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody sx={{ backgroundColor: "#fff" }}>
                  {dialogData.map((cyl, index) => (
                    <StyledTableRow key={index}>
                      <TableCell align="center" sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{index + 1}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.cylinder_no}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.tag_no}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.owner}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.booked}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.status || "-"}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.note || "-"}</TableCell>
                      <TableCell sx={{ fontFamily: "Inter, sans-serif", fontSize: 13 }}>{cyl.storage || "-"}</TableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default ViewStockcyl;